import React, { useState, useEffect } from "react";
import "./register.css";
import { AuthShell } from "../auth/AuthBackground";
import { useNavigate } from "react-router-dom";
import { TbPasswordMobilePhone } from "react-icons/tb";
import { useSearchParams } from "react-router-dom";
import { alertToast } from "../../alertToast";
import Base_Url from "../../config";
import { AiOutlineEyeInvisible } from "react-icons/ai";
import { MdOutlineRemoveRedEye } from "react-icons/md";
import { CiLock } from "react-icons/ci";
import { CiMobile3 } from "react-icons/ci";


import { CiMail } from "react-icons/ci";


export const Register = () => {
  const navigate = useNavigate();
  // State management
  const [phoneNumber, setPhoneNumber] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [referralCode, setReferralCode] = useState("");
  const [termsAccepted, setTermsAccepted] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isPasswordVisible, setIsPasswordVisible] = useState(false);

  const [searchParams] = useSearchParams();
  useEffect(() => {
    // Add any initialization logic here if needed
    const referral = searchParams.get("referral");
    if(referral){
        setReferralCode(referral); //automatically we assign from query params
    }
    return () => {
      // Cleanup if needed when component unmounts
      console.log("Register component unmounted");
    };
  }, []);

  const handleRegistration = async (e) => {
    e.preventDefault();
    if (isSubmitting) return;

    if (password !== confirmPassword) {
      alertToast("Passwords do not match", "error");
      return;
    }

    if (!termsAccepted) {
      alertToast("You must accept the terms and conditions", "error");
      return;
    }

    setIsSubmitting(true);
    try {
      const response = await fetch(
         `${Base_Url}/auth/signup/get-otp`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            phoneNumber,
          }),
        }
      );

      const data = await response.json();
      console.log(data);
      // Handle the response as needed
      if (response.ok) {
        navigate("/verification", {
          state: { email, password, phoneNumber, referralCode },
        });
      } else {
        alertToast("Registration failed: " + data.error, "error");
      }
    } catch (error) {
      console.error("Error:", error);
      alertToast("An error occurred during registration", "error");
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <AuthShell wide>
      <h1 className="ic-auth-title">Create your account</h1>
      <p className="ic-auth-sub">
        Enter your details to receive a verification code.
      </p>
      <form onSubmit={handleRegistration}>
      <div className="ic-field">
        <label htmlFor="register-phone">Phone number</label>
        <span className="ic-ico"><CiMobile3 /></span>
        <input
          id="register-phone"
          type="tel"
          inputMode="tel"
          autoComplete="tel"
          required
          className="ic-input"
          placeholder="Enter your phone number"
          value={phoneNumber}
          onChange={(e) => setPhoneNumber(e.target.value)}
        />
      </div>
      <div className="ic-field">
        <label htmlFor="register-email">Email</label>
        <span className="ic-ico"><CiMail /></span>
        <input
          id="register-email"
          type="email"
          autoComplete="email"
          required
          className="ic-input"
          placeholder="Enter your email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
        />
      </div>
      <div className="ic-field">
        <label htmlFor="register-password">Password</label>
        <span className="ic-ico"><CiLock /></span>
        <input
          id="register-password"
          type={isPasswordVisible ? "text" : "password"}
          autoComplete="new-password"
          minLength={6}
          required
          className="ic-input"
          placeholder="Create a password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
        />
        <button type="button" className="ic-eye" aria-label={isPasswordVisible ? "Hide password" : "Show password"}
          aria-pressed={isPasswordVisible} onClick={() => setIsPasswordVisible(!isPasswordVisible)}>
          {isPasswordVisible ? <MdOutlineRemoveRedEye /> : <AiOutlineEyeInvisible />}
        </button>
      </div>
      <div className="ic-field">
        <label htmlFor="register-confirm-password">Confirm password</label>
        <span className="ic-ico"><CiLock /></span>
        <input
          type="password"
          id="register-confirm-password"
          autoComplete="new-password"
          minLength={6}
          required
          className="ic-input"
          placeholder="Re-enter your password"
          value={confirmPassword}
          onChange={(e) => setConfirmPassword(e.target.value)}
        />
      </div>
      <div className="ic-terms">
        <input
          type="checkbox"
          name="terms"
          id="terms"
          checked={termsAccepted}
          required
          onChange={(e) => setTermsAccepted(e.target.checked)}
        />
        <label htmlFor="terms">I have read and agree to the terms and conditions</label>
      </div>
      <button type="submit" className="ic-btn" disabled={isSubmitting} aria-busy={isSubmitting}>
        {isSubmitting ? "Sending code…" : "Send verification code"}
      </button>
      </form>
      <div className="ic-links center">
        <span style={{ color: "#9fb3a8" }}>Already have an account?</span>
        <button type="button" className="ic-link" onClick={() => navigate("/login")}>
          Log in
        </button>
      </div>
    </AuthShell>
  );
};
